<template>
    <div class="expert-panel-session">
        <Breadcrumbs :items="breadcrumbs"/>

        <main>
            <ExpertWorkSession
                v-if="ready"
                :type="type"
                :eid="eventId"
                :event-path="eventPath"
                :session="workSession"
                :user="user"
            />

            <Wait v-else/>
        </main>
    </div>
</template>

<script>
import Breadcrumbs from '@/components/UI/Breadcrumbs';
import ExpertWorkSession from '@/components/expert-panel/ExpertWorkSession';
import Wait from '@/components/Wait';

export default {
    name: 'ExpertPanelSession',
    computed: {
        type() {
            return this.$route.params['type'];
        },
        eventId() {
            return +this.$route.params['event'];
        },
        event() {
            const type = this.$store.state.examination.events[this.type];

            return type ? type.items.find(t => t.id == this.eventId) : null;
        },
        sessionId() {
            return +this.$route.params['session'];
        },
        name() {
            return this.event ? this.event.name : '';
        },
        eventPath() {
            return `/expert-panel/${this.type}/${this.eventId}`;
        },
        breadcrumbs() {
            return [
                { text: 'Личный кабинет эксперта', path: { name: 'expert-panel' } },
                { text: this.name, path: this.eventPath },
                { text: this.sessionId, path: this.$route.path },
            ];
        },
        workSession() {
            return this.$store.state.examination.workSession;
        },
        user() {
            if (!this.workSession) return null;

            return this.workSession.userId
                ? this.$store.getters['users/byId'](this.workSession.userId)
                : null;
        },
        ready() {
            if (!this.workSession) return false;

            return Boolean(!this.workSession.userId || this.user);
        },
    },
    methods: {
        checkLoadSession(res) {
            this.$store.dispatch('examination/unloadSessions');

            if (!res) return this.$router.replace(this.eventPath);
        },
    },
    components: {
        Breadcrumbs,
        ExpertWorkSession,
        Wait,
    },
    created() {
        this.$store.dispatch('examination/loadEvents');

        const workSessionConfig = {
            type: this.type,
            eid: this.eventId,
            sid: this.sessionId,
        };

        this.$store
            .dispatch('examination/loadWorkSession', workSessionConfig)
            .then(this.checkLoadSession);
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/rem';

    .expert-panel-session {
        padding-left: rem(189);
        font-family: 'Open Sans', sans-serif;
    }

    main {
        width: rem(1542);
        min-height: rem(300);
    }
</style>
